(ns dre.pages.my-searches.search-history.views
  (:require
   [dre.app.events :as app-events]
   [dre.app.router :as router :refer [->route]]
   [dre.components.table :refer [table]]
   [dre.components.icon :refer [fa-icon icon svg]]
   [dre.modals.events :as-alias modals]
   [dre.pages.my-searches.search-history.events :as events]
   [dre.pages.my-searches.views :as my-searches]
   [dre.i18n.views :refer [tr]]
   [dre.i18n.events :as-alias i18n]
   [dre.utils :refer [roles-hash]]
   [dre.utils.bem :as bem]
   [dre.utils.query :as q]
   ["moment" :as moment]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(def component-name :search-history)

(defn event-detail [event r-hash ev]
  (doto ev .preventDefault event)
  (let [search-query {:query/type :articles
                      :query/pills (:payload event)}
        route (q/route search-query r-hash)]
    (rf/dispatch [::router/redirect-to-path-with-query-params (->route :search) (:query-params route)])))

(defn date->yyyy-mm-dd
  [date]
  (when date
    (let [m (moment date)]
      (.format m "YYYY-MM-DD"))))

(defn view
  []
  (let [user @(rf/subscribe [::app-events/user])
        r-hash (roles-hash user)]
    [:div
     {:class component-name}
     [:div
      {:class (bem/be component-name :nav)}
      [my-searches/view]]
     [:div
      {:class (bem/be component-name :content)}
      [table
       {:columns (remove nil? [{:title [tr "Title"]
                                :render (fn [{:keys [title] :as event}]
                                          [:a
                                           {:on-click (partial event-detail event r-hash)}
                                           title])
                                :dataIndex :title
                                :sorter :default}
                               {:title [tr "Query"]
                                :render (fn [{:keys [payload] :as event}]
                                          (events/render-event payload))}
                               {:title [tr "Date"]
                                :render (fn [{:keys [_created] :as event}]
                                          [:span (date->yyyy-mm-dd _created)])
                                :dataIndex :_created
                                :sorter :default}
                               {:title ""
                                :render (fn [{:keys [payload signal title] :as event}]
                                          (if signal
                                            [:span
                                             {:class (bem/be component-name :action-buttons)}
                                             [:span
                                              {:onClick #(rf/dispatch [::modals/set-modal :my-searches.signals/edit {:data-edit signal}])}
                                              [svg :common :edit]]]
                                            [:span
                                             {:class (bem/be component-name :action-buttons)}
                                             [:span
                                              {:onClick #(rf/dispatch [::modals/set-modal :my-searches.signals/edit
                                                                       {:data-edit {:query/search-query {:query/type :articles
                                                                                                         :query/pills (:payload event)}}}])}
                                              [svg :common :save]]]))}])
        :dataSource (reverse (sort-by :_created @(rf/subscribe [::events/data])))
        :loading? @(rf/subscribe [::events/loading?])
        :rowKey (fn [element] (str (hash element)))
        :pagination {:defaultPageSize 10
                     :hideOnSinglePage true}}]]]))
